import React from "react"

import Icon from "@/components/Icon"
import { Card } from "@/components/ui/card"
import { formatPhoneNumber } from "@/helpers/phoneNumber"

type Props = {
  buttons: React.ReactNode
  campaignName: string
  displayTime: string | null
  error?: React.ReactNode
  phoneNumber: string | null
  status?: React.ReactNode
}

export function CallPanelCard({
  buttons,
  campaignName,
  displayTime,
  error,
  phoneNumber,
  status,
}: Props) {
  return (
    <Card className="rounded-sm">
      <div className="flex flex-col gap-6 px-4 py-6">
        <div
          className="
            flex flex-col gap-y-2 font-body-large-bold text-neutral-600
          "
        >
          <p data-unmask>{campaignName}</p>
          <div className="flex flex-wrap items-center justify-between">
            <div
              className="
                flex flex-wrap items-center gap-x-2 font-body-medium-bold
              "
            >
              <p className="font-body-large-regular" data-unmask>
                {formatPhoneNumber(phoneNumber)}
              </p>
              {status}
            </div>
            <div
              className="flex items-center gap-x-1 font-body-large-regular"
              data-unmask
            >
              {displayTime}
            </div>
            {error && (
              <div
                className="
                  mt-4 flex w-full items-center gap-x-1 rounded-sm border
                  border-danger-300 bg-danger-200 px-4 py-6 font-h4-bold
                  text-neutral-100
                "
                data-unmask
              >
                <Icon name="alert" size="sm" />
                <h4 data-unmask>{error}</h4>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-wrap gap-2">{buttons}</div>
      </div>
    </Card>
  )
}
